import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface IContentPart {
  filter: React.ReactNode;
  table: any;
  width?: any;
  setHeight?: (h: number) => void;
}

export const ContentPartHistoryReservoir = (props: IContentPart) => {
  const { t } = useTranslation();

  const ref = useRef(null);
  useEffect(() => {
    if(ref.current !== null && props.setHeight !== undefined){
      let element = ref.current as HTMLElement;
      props.setHeight(element.clientHeight - 50); 
    }
  }, [ref])

  return (
    <div ref={ref}  id='contentPart'>
      <div className="contentRes">
      
        <div className={`sideFilterRes active`}>
   
          <div className="filterContent">
            {props.filter}
          </div>
        </div>
        <div className="sideTable" style={{ width: '100%', height: '100%' }}>
          <div className="tableBlock">
            {React.cloneElement(props.table, { className: "table" })}
          </div>
        </div>
      </div>
    </div>
  )
}